import { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpandAlt, faCompressAlt } from "@fortawesome/free-solid-svg-icons";
import CheckBox from "./CheckBox";
import themeColors from "../../config/themeColors";
import { KleurStatusEnum } from "../../client/procescontroleclient";

const Card = styled.div<{ red: boolean, yellow: boolean, darkred: boolean, orange: boolean, height: boolean }>`
  border-radius: 21px;
  background-color: #fff;  
  ${props => props.red ? 'background-color: rgba(204,114,106,0.3)!important;' : null}
  ${props => props.yellow ? 'background-color: rgba(255, 204, 0, 0.3)!important;' : null}
  ${props => props.darkred ? 'background-color: rgba(153, 0, 0, 0.3)!important;' : null}
  ${props => props.orange ? 'background-color: rgb(235 157 110 / 60%) !important;' : null}
  box-shadow: 0px 5px 9.5px 0.5px rgba(0, 0, 0, 0.03);
  margin-bottom: .8rem;
  padding: 1rem;
  transition: max-height .6s ease;
  min-height: 66px;
  max-height: ${props => props.height ? '340px' : '0px'};
  overflow: hidden;
  position: relative;
`;
const Heading = styled.div`
 display: flex;
 align-items: center;
 flex-wrap: wrap;
`;
const StyledCheckBox = styled(CheckBox)<{ checked?: boolean }>`
  min-width: 30px;
  height: 30px;
  margin-right: .5rem;
  margin-left: 0;
  background: #f5f6f9;
  border: 2px solid #7c93aa;
  svg {
    font-size: 1.1rem;
    color: ${themeColors.ftgBlue};
    position: relative;
    top: 3px;
    left: 3px;
  }
  ${props => props.checked ? `border-color: ${themeColors.ftgBlue};` : null}
`;

const Compact = styled.div<{ opacity: boolean }>`
  transition: opacity .5s ease;
  display: flex;
  opacity: ${props => props.opacity ? 0 : 1};
  font-size: 82%;
  color: #7c93aa;
  width: 52%;
  justify-content: space-between;
  align-items: center;
  div {
    margin-left: .5rem;
    word-break: break-word;
    strong {
      margin-right: .2rem;
    }
  }
`;
const Expand = styled.div<{ height: boolean }>`
  margin-top: .8rem;
  transition: opacity .5s ease;
  opacity: ${props => props.height ? 1 : 0};
`;
const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  margin: auto 0 auto auto;
  font-size: 1.5rem;
  color: #7c93aa;
  position: absolute;
  right: 0;
  z-index: 1;
  padding: .7rem;
`;
const Title = styled.div`
  font-size: 95%;
  font-weight: bold;
  color: ${themeColors.ftgBlue};
  white-space: pre-wrap;
  min-width: 55px;
  max-width: 75px;
`;
export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 80%;
  padding: .4rem .9rem;
  border-radius: 20px;
  color: #7c93aa;
  :nth-of-type(odd) {
    background: #f1f2f6;
  }
  div:last-child {
    margin-right: 0;
  }
`;
export const Item = styled.div`
  display: flex;
  justify-content:space-between;
  margin-right: 1rem;
  flex: 1;
`;
export const Label = styled.div`
  margin-right: .5rem;
`;
export const Field = styled.div`
  font-weight: bold;
`;
interface Props {
  color: KleurStatusEnum;
  compactView: React.ReactElement;
  expandView: React.ReactElement;
  checked: boolean | undefined;
  onclick?: () => void;
  title: string;
  subtitle?: string;
}

const ProcesControleMobileCard = ({ color, compactView, expandView, onclick, checked, title, subtitle }: Props) => {

  const [isExpanded, setIsExpanded] = useState(false);

  return(
    <Card red={color===KleurStatusEnum.Red} yellow={color===KleurStatusEnum.Yellow} darkred={color===KleurStatusEnum.DarkRed} orange={color===KleurStatusEnum.Orange} height={isExpanded}>
        <Heading>
          {onclick && checked !== undefined ? <StyledCheckBox onClick={onclick} checked={checked} /> : null}
          <Title>
            {title.substring(0, 12)}{title.length >= 12 && '..'} {isExpanded && subtitle}
          </Title>
          <Compact opacity={isExpanded}>
            {compactView}
          </Compact>
          <StyledFontAwesomeIcon icon={!isExpanded ? faExpandAlt : faCompressAlt} onClick={() => setIsExpanded(!isExpanded)} />
        </Heading>
        <Expand height={isExpanded}>
            {expandView}
        </Expand>
    </Card>
  );
}

export default ProcesControleMobileCard;
